import axios from 'axios';
import Layout from '../shared/Layout';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FormClient from './FormClient';
import {  useNavigate } from 'react-router-dom';
import '../../css/client-card.css';
const Card = () => {
  const { id } = useParams();
    const url = '/api/clients/'+id;
    const [refresh, setRefresh] = useState(0);
    const [data, setData] = useState({});
    const navigate = useNavigate();

    const onRefreshHundler = ()=> {
        setRefresh(prev => prev==="1" ? "0" : "1");
    }

   useEffect(()=>{
    axios.get(url, { withCredentials: true })
    .then(response => {
       setData(response.data);
    })
    .catch(err => {
       if(err.response && err.response.status === 401 ){
          navigate('/login');
        }
    });
 },[url,refresh])

  return (
    <Layout>
    <main className='main-block' >
      <div className='main-content client-card-page' >
        <FormClient
         clientId={id}
         url={url}
         data={data}
         onRefreshHundler={onRefreshHundler} ></FormClient>
      </div>
    </main>

  </Layout>
  )
}

export default Card;
